// sw-size.js
(function () {
  function roundTo(value, decimals) {
    const p = Math.pow(10, decimals);
    return Math.round(value * p) / p;
  }

  function inToCm(inches) {
    return inches * 2.54;
  }

  // Optional: supports "19 1/2" or "1/2"
  function parseInches(raw) {
    if (raw == null) return NaN;
    const str = String(raw).trim();
    if (!str) return NaN;

    // Plain number like "19" or "19.5"
    const direct = Number(str);
    if (!Number.isNaN(direct)) return direct;

    // Mixed fraction like "19 1/2"
    const parts = str.split(" ");
    if (parts.length === 2) {
      const whole = Number(parts[0]);
      const frac = parts[1].split("/");
      if (!Number.isNaN(whole) && frac.length === 2) {
        const num = Number(frac[0]);
        const den = Number(frac[1]);
        if (!Number.isNaN(num) && !Number.isNaN(den) && den !== 0) {
          return whole + num / den;
        }
      }
    }

    // Fraction like "1/2"
    const fracOnly = str.split("/");
    if (fracOnly.length === 2) {
      const num = Number(fracOnly[0]);
      const den = Number(fracOnly[1]);
      if (!Number.isNaN(num) && !Number.isNaN(den) && den !== 0) {
        return num / den;
      }
    }

    return NaN;
  }

  function formatNumber(n, unit) {
    if (unit === "cm") return String(roundTo(n, 1));
    const rounded = roundTo(n, 1);
    return String(rounded);
  }

  function setActiveButtons(container, unit) {
    const btns = container.querySelectorAll(".sw-size__unit-btn");
    btns.forEach((b) => {
      const isActive = b.getAttribute("data-unit") === unit;
      b.classList.toggle("is-active", isActive);
      b.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateTable(container, unit) {
    container.setAttribute("data-unit", unit);

    const cells = container.querySelectorAll("[data-in]");
    cells.forEach((cell) => {
      const raw = cell.getAttribute("data-in");
      const inches = parseInches(raw);
      if (Number.isNaN(inches)) return;

      if (unit === "cm") {
        cell.textContent = formatNumber(inToCm(inches), "cm");
      } else {
        cell.textContent = formatNumber(inches, "in");
      }
    });

    setActiveButtons(container, unit);
  }

  function init(container) {
    if (!container || container.dataset.swSizeInit === "true") return;
    container.dataset.swSizeInit = "true";

    const defaultUnit = (container.getAttribute("data-unit") || "in").toLowerCase();
    updateTable(container, defaultUnit);

    container.addEventListener("click", (e) => {
      const btn = e.target.closest(".sw-size__unit-btn");
      if (!btn) return;

      const unit = (btn.getAttribute("data-unit") || "").toLowerCase();
      if (!unit) return;

      updateTable(container, unit);
    });
  }

  function bootAll() {
    document.querySelectorAll(".sw-size").forEach(init);
  }

  // Helps if the accordion content is injected/revealed after load
  function observeForNewCharts() {
    const obs = new MutationObserver(() => bootAll());
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootAll();
      observeForNewCharts();
    });
  } else {
    bootAll();
    observeForNewCharts();
  }
})();
